const projects = [
  {
    title: "Evidenca",
    category: "Full Stack · React",
    desc: "Complete time-tracking and employee management platform with real-time data, JWT authentication, admin dashboard and detailed reporting.",
    image: "/evidenca-picture.png",
    live: "https://www.evidenca.net",
    github: "https://github.com/stefanlatic",
    tags: ["React", "Node.js", "MongoDB", "Express"],
  },
  {
    title: "Gali Tekstil",
    category: "E-Commerce · Next.js",
    desc: "Full-featured e-commerce platform for a textile company — product catalog, shopping cart, checkout flow, order tracking, and a complete admin panel.",
    image: null,
    gradient: "from-purple-900 to-indigo-900",
    tags: ["Next.js", "MongoDB", "Mongoose", "Tailwind CSS"],
  },
  {
    title: "Vartig",
    category: "Company Website · Vue.js",
    desc: "Professional website for a metal manufacturing firm with a full multilingual system (SR / EN / DE), service catalog, and machines park gallery.",
    image: null,
    gradient: "from-emerald-900 to-teal-900",
    tags: ["Vue.js", "Vue Router", "Vue i18n", "Tailwind CSS"],
  },
  {
    title: "My Library App",
    category: "Frontend · React",
    desc: "A personal book management application to track your reading list, add new books and keep your library organised with a clean, minimal UI.",
    image: "/mylibrary-picture.png",
    live: "https://my-library-app-jade.vercel.app",
    github: "https://github.com/stefanlatic",
    tags: ["React", "Tailwind CSS"],
  },
  {
    title: "To-Do App",
    category: "Frontend · React",
    desc: "A clean task management application with filtering, priority levels and localStorage persistence — built to practice React state and hooks.",
    image: "/toDo-picture.png",
    live: "https://to-do-app-phi-two.vercel.app",
    github: "https://github.com/stefanlatic",
    tags: ["React", "CSS"],
  },
  {
    title: "Stefan Latić Dev",
    category: "Portfolio · React",
    desc: "This portfolio website — Carlos Mendoza-inspired layout, dark theme, custom scroll interactions, full contact form powered by EmailJS.",
    image: null,
    gradient: "from-orange-900 to-yellow-900",
    tags: ["React", "Tailwind CSS", "EmailJS", "CRA"],
  },
];

const WorksSection = () => (
  <section id="works" className="bg-[#0d0e18] py-24 px-6 md:px-12 lg:px-20">
    <div className="max-w-7xl mx-auto">

      {/* Header */}
      <p className="text-[#f5c210] text-xs tracking-[0.2em] uppercase font-IBM mb-4">— Portfolio</p>
      <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14">
        <div>
          <h2 className="font-IBM font-bold text-white text-4xl md:text-5xl leading-tight">
            All Creative Works,
          </h2>
          <h2 className="font-IBM font-bold text-white text-4xl md:text-5xl leading-tight">
            Selected Projects.
          </h2>
        </div>
        <a
          href="https://github.com/stefanlatic"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-[#f5c210] font-IBM text-sm mt-6 md:mt-0 group"
        >
          View all on GitHub
          <span className="transition-transform group-hover:translate-x-1">→</span>
        </a>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {projects.map((p) => (
          <div
            key={p.title}
            className="group bg-[#131523] border border-[#1e2030] rounded-xl overflow-hidden hover:border-[#f5c210]/40 transition-all duration-300 hover:-translate-y-1 flex flex-col"
          >
            {/* Image or gradient */}
            <div className="relative h-44 overflow-hidden">
              {p.image ? (
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              ) : (
                <div className={`w-full h-full bg-gradient-to-br ${p.gradient} flex items-center justify-center`}>
                  <span className="font-IBM font-bold text-white/20 text-4xl">{p.title[0]}</span>
                </div>
              )}
              {/* Category badge */}
              <div className="absolute top-3 left-3">
                <span className="bg-[#0d0e18]/80 backdrop-blur-sm text-[#f5c210] font-IBM text-xs tracking-widest uppercase px-2.5 py-1 rounded">
                  {p.category}
                </span>
              </div>
            </div>

            {/* Content */}
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-IBM font-semibold text-white text-lg mb-2 group-hover:text-[#f5c210] transition-colors">
                {p.title}.
              </h3>
              <p className="font-IBM text-gray-400 text-sm leading-relaxed mb-4 flex-1">
                {p.desc}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-1.5 mb-5">
                {p.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs font-IBM text-gray-500 border border-[#2a2d3e] rounded-full px-2.5 py-0.5"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* Links */}
              <div className="flex items-center gap-4">
                {p.live && (
                  <a
                    href={p.live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs font-IBM text-[#f5c210] hover:underline"
                  >
                    Live ↗
                  </a>
                )}
                {p.github && (
                  <a
                    href={p.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs font-IBM text-gray-500 hover:text-white transition-colors"
                  >
                    GitHub ↗
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WorksSection;
